<template>
	<div class="mt-8 mb-20 mr-10 ml-10 justify-center">
		<div class="justify-center flex">
			<img src="@/assets/car_lock.png" alt="verriegeltes auto" style="width: 100px; color: #3c81df" />
		</div>
		<div style="font-weight: bold; font-size: 25px; margin-top: 12px; text-align: center">{{ $t('access_denied').toString() }}</div>
	</div>
</template>

<script>
export default {
	name: 'Forbidden',
};
</script>

<style scoped></style>
